// src/widgets/BuilderViewWidget.tsx

import { ResponseEventItem, ResponseEventUpdate } from './ResponseEventWidget';
import { InstanceEventWidget } from './InstanceEventWidget';
import { RealtimeEvent } from '../utils/events.js';
import { MemoryIndexes } from '../contexts/FabricServiceContext';
import { AgentDescription } from '../types/AgentDescription';


interface BuilderViewWidgetProps {

}

export const BuilderViewWidget: React.FC<BuilderViewWidgetProps> = ({

}) => {

  const displayMode = (eventItem: ResponseEventItem) => {
    return eventItem.data?.selected ? 'selected' : (eventItem.data?.selected === false ? 'unselected' : '')
  }

  const itemContent = (eventItem: ResponseEventItem) => {

    const mode = displayMode(eventItem)

    const memoryContent = (eventItem: ResponseEventItem) => {
      if (!eventItem.data) return

      return (
        <div>
          <div className={`memory-content unselected`}>{eventItem.data.question}</div>
          <div className={`memory-content ${mode}`}>{eventItem.data.answer}</div>
        </div>
      )
    }

    return (
      <div className="memory-row">
        <div>
          {memoryContent(eventItem)}
        </div>
        <div className={`memory-timestamp ${mode}`}>
          {eventItem.data?.timestamp.toLocaleDateString('en-US', {
            weekday: 'short',
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            // hour: 'numeric',
            // minute: 'numeric',
            // hour12: true,
          })}
        </div>
      </div>
    )
  }

  const speakerName = (eventItem: ResponseEventItem) => {
    return <div className={`memory-speaker ${displayMode(eventItem)}`}>{AgentDescription(eventItem.data?.source || '', (eventItem.role === 'assistant' ? 'assistant' : undefined)).name}</div>
  }

  const filterCondition = (eventItem: ResponseEventItem, selectedModule: string, selectedFilters: (string | undefined)[]) => {
    if (selectedModule != '' && !eventItem.type.includes(selectedModule)) {
      return false;
    }
    if (selectedFilters.includes(eventItem.data?.source || '')) {
      return false;
    }
    return true
  }

  const eventUpdate = (realtimeEvent: RealtimeEvent, output: ResponseEventUpdate, memoryIndexes?: MemoryIndexes[]) => {

    const itemOutput = realtimeEvent.event.item.output[0]
    const instanceOutput = realtimeEvent.event.instance

    const item: ResponseEventItem = {
      responseId: realtimeEvent.event.item.id,
      id: realtimeEvent.event.item.id,
      role: [itemOutput.metadata.source].includes(instanceOutput.entity_name) ? 'assistant' : '',
      type: 'episodic',
      output: itemOutput,
      data: {
        timestamp: new Date(itemOutput.metadata.timestamp),
        source: itemOutput.metadata.source,
        question: itemOutput.question,
        answer: itemOutput.answer,
        selected: undefined
      }
    }

    output.items.push(item)
    output.filters.push({
      label: AgentDescription(item.data!.source, item.role === 'assistant' ? item.role : undefined).name,
      value: item.data!.source
    })
    output.modules.push(item.type)

    //Sort the items by timestamp descending
    output.items.sort((a: ResponseEventItem, b: ResponseEventItem) => {
      return b.data!.timestamp.getTime() - a.data!.timestamp.getTime()
    })
  }

  return (
    <InstanceEventWidget
      eventType='builder viewer'
      storageField='fabric_builder_filters'
      placeholder='awaiting memories...'
      itemContent={itemContent}
      speakerName={speakerName}
      filterCondition={filterCondition}
      eventUpdate={eventUpdate}
    />
  )
};